var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.562495H2.25C1.80756 0.557992 1.3814 0.729191 1.06504 1.03853C0.74867 1.34786 0.56794 1.77006 0.5625 2.2125V21.7912C0.568923 22.233 0.750087 22.6543 1.06634 22.9628C1.3826 23.2713 1.8082 23.442 2.25 23.4375H21.75C22.1925 23.441 22.6183 23.2692 22.9345 22.9597C23.2507 22.6502 23.4316 22.2281 23.4375 21.7856V2.20687C23.4296 1.76574 23.2479 1.34555 22.9319 1.03763C22.6159 0.729716 22.1912 0.558966 21.75 0.562495Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94871 9.13687H7.34434V20.0625H3.94871V9.13687ZM5.64746 3.69937C6.03692 3.69937 6.41764 3.81488 6.74143 4.0313C7.06523 4.24771 7.31757 4.5553 7.46653 4.91515C7.61548 5.275 7.65436 5.67094 7.57824 6.0529C7.50213 6.43485 7.31444 6.78564 7.03891 7.0609C6.76339 7.33616 6.41242 7.52352 6.0304 7.59927C5.64837 7.67502 5.25246 7.63577 4.89275 7.48647C4.53304 7.33717 4.2257 7.08454 4.00959 6.76054C3.79349 6.43653 3.67834 6.05571 3.67871 5.66625C3.67921 5.14443 3.88685 4.64415 4.25601 4.27534C4.62517 3.90653 5.12564 3.69937 5.64746 3.69937ZM9.47434 9.13687H12.7293V10.6369H12.7743C13.2281 9.77812 14.3343 8.8725 15.9862 8.8725C19.425 8.865 20.0625 11.1281 20.0625 14.0625V20.0625H16.6668V14.7469C16.6668 13.4812 16.6443 11.8519 14.9025 11.8519C13.1606 11.8519 12.8643 13.2319 12.8643 14.6644V20.0625H9.47434V9.13687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1e0e346cd6adcafcb5da9285fd6ee3aa.svg";
export { ForwardRef as ReactComponent };